module.exports = __webpack_public_path__ + "static/media/archive.1067bc6b.svg";